import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import type { HypersceneAdvancedDemo } from '../../hyperscene-advanced.component';

/**
 * The Settings tab: render pipeline, camera, Frustum and debug settings. The page owns the state; this component only
 * renders it, so it is checked with the page.
 */
@Component({
  selector: 'section[viewer-settings-panel]',
  templateUrl: './viewer-settings-panel.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class ViewerSettingsPanelComponent {
  @Input({ required: true }) public viewer!: HypersceneAdvancedDemo;
}
